import { Box } from '@chakra-ui/react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FileUploadButton } from '@/components/FileUploadButton';

export const AttachmentButton: React.FC<{ attachmentLimit?: number }> = ({
  attachmentLimit,
}) => {
  const { trigger } = useFormContext();

  return (
    <Box>
      <Controller
        name="attachments"
        rules={{
          validate: (value) =>
            attachmentLimit === undefined ||
            !value ||
            value.length <= attachmentLimit ||
            `Cannot attach more than ${attachmentLimit} file${
              attachmentLimit !== 1 ? 's' : ''
            } `,
        }}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <FileUploadButton
            colorScheme="gray"
            variant="ghost"
            value={value}
            onChange={(value) => {
              onChange(value);
              trigger('attachments');
            }}
            onBlur={onBlur}
            ref={ref}
          />
        )}
      />
    </Box>
  );
};
